module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit_page_name":"Edit page name","page_name":"Page name","your_customer_wont_see":"Your customers won’t see this."},"id":{"edit_page_name":"Edit nama judul","page_name":"judul","your_customer_wont_see":"Tidak akan kelihatan untuk pelanggan"}}')
  delete Component.options._Ctor
}
